import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './index.module.scss';

export const StandardPricing = () => {
  const { t } = useTranslation('fpg-v1');
  return (
    <div className={s.wrapper}>
      <div className={s.inner}>
        <table className={classnames(s.table_standard, 'text_l')}>
          <tbody>
            <tr>
              <td>{t('fpg_pricing.risk_factor')}</td>
              <td>{t('fpg_pricing.low')}</td>
              <td>{t('fpg_pricing.medium')}</td>
              <td>{t('fpg_pricing.high')}</td>
            </tr>
            <tr>
              <td>{t('fpg_pricing.cap_fee', { percentage: '70%' })} *</td>
              <td>{t('fpg_pricing.no_fee')}</td>
              <td>{t('fpg_pricing.no_fee')}</td>
              <td>{t('fpg_pricing.no_fee')}</td>
            </tr>
            <tr>
              <td>{t('fpg_pricing.cap_fee', { percentage: '50%' })}</td>
              <td>0.75%</td>
              <td>1.25%</td>
              <td>2.00%</td>
            </tr>
            <tr>
              <td>{t('fpg_pricing.cap_fee', { percentage: '20%' })}</td>
              <td>1.25%</td>
              <td>1.55%</td>
              <td>{t('fpg_pricing.no_access')}</td>
            </tr>
          </tbody>
        </table>
        <div className={classnames(s.note, 'f-body-regular')}>
          <span>*</span>
          <div>{t('fpg_pricing.note', { percentage: '70%' })}</div>
        </div>
      </div>
    </div>
  );
};
